export const makeAbortActionCreator = (type) => (payload = {}) => ({
  type: `${type}/ABORT`,
  payload,
});
